import clsx from "clsx"

import { Skeleton } from "@particles/index"

import useListItem from "@molecules/ListItem/ListItem.context"

import styles from "./ListItemContent.module.scss"
import { ListItemContentProps } from "./ListItemContent.types"

function LoadingRow() {
    return <Skeleton height={10} width="100%" borderRadius={0} />
}

export default function ListItemContent(props: ListItemContentProps) {
    const {
        leftLabel = null,
        rightLabel = null,
        leftCaption = null,
        rightCaption = null,
        rightTag = null,
        progressBar = null,
        isLoading,
        isReversed = false,
    } = props

    const { isLoading: listItemIsLoading } = useListItem()
    const resolvedIsLoading = typeof isLoading === "boolean" ? isLoading : listItemIsLoading

    const hasCaption = Boolean((leftCaption || rightCaption) && !progressBar)

    if (resolvedIsLoading) {
        return (
            <div className={clsx(styles.base, { [styles.reversed]: isReversed })}>
                <LoadingRow />
                {hasCaption && <LoadingRow />}
                {progressBar && <LoadingRow />}
            </div>
        )
    } else if (progressBar) {
        return (
            <div className={clsx(styles.base, { [styles.reversed]: isReversed })}>
                <div className={styles.row}>
                    {leftLabel}
                    {rightLabel}
                </div>
                <div className={styles.row}>
                    <div className={styles.progressBarWrapper}>{progressBar}</div>
                </div>
            </div>
        )
    } else {
        return (
            <div className={clsx(styles.base, { [styles.reversed]: isReversed })}>
                <div className={styles.content}>
                    <div className={styles.column}>
                        {leftLabel}
                        {leftCaption}
                    </div>
                    {(rightLabel || rightCaption || rightTag) && (
                        <div className={styles.column}>
                            {rightLabel}
                            {rightCaption}
                            {rightTag}
                        </div>
                    )}
                </div>
            </div>
        )
    }
}
